<template>
    <v-card flat rounded="0">
        <v-navigation-drawer
            app
            right
            v-model="drawer"
            disable-resize-watcher
            class="grey lighten-4"
        >
            <v-app-bar class="grey darken-4" elevation="0" dark>
                <v-toolbar-title>{{ $t('filters.title') }}</v-toolbar-title>

                <v-spacer></v-spacer>

                <v-btn icon @click="drawer = false">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-app-bar>
            <v-divider></v-divider>

            <v-list dense nav>
                <v-list-item
                    v-for="(item, key) in allowed"
                    :key="resource + key"
                >
                    <CheckFilter
                        v-if="item.type == 'check'"
                        :name="key"
                        :resource="resource"
                    />

                    <MonthYearFilter
                        v-else-if="item.type == 'month-year'"
                        :name="key"
                        :resource="resource"
                    />

                    <SearchFilter
                        v-else-if="item.type == 'search'"
                        :name="key"
                        :resource="resource"
                    />

                    <SelectFilter
                        v-else-if="item.type == 'select'"
                        :name="key"
                        :options="item.options"
                        :resource="resource"
                    />

                    <PeriodFilter
                        v-else-if="item.type == 'period'"
                        :name="key"
                        :resource="resource"
                    />

                    <RadioFilter
                        v-else-if="item.type == 'radio'"
                        :name="key"
                        :options="item.options"
                        :resource="resource"
                    />

                    <TextFilter
                        v-else-if="item.type == 'text'"
                        :name="key"
                        :resource="resource"
                    />

                    <NumericFilter
                        v-else-if="item.type == 'numeric'"
                        :name="key"
                        :resource="resource"
                    />
                </v-list-item>
            </v-list>

            <template v-slot:append>
                <div class="pa-2">
                    <v-btn
                        block
                        class="grey darken-4"
                        :dark="true"
                        @click="reset()"
                    >
                        {{ $t('filters.reset') }}
                    </v-btn>
                </div>
            </template>
        </v-navigation-drawer>
    </v-card>
</template>

<script>
import CheckFilter from './CheckFilter'
import MonthYearFilter from './MonthYearFilter'
import NumericFilter from './NumericFilter'
import RadioFilter from './RadioFilter'
import SearchFilter from './SearchFilter'
import SelectFilter from './SelectFilter'
import PeriodFilter from './PeriodFilter'
import TextFilter from './TextFilter'

export default {
    components: {
        CheckFilter,
        MonthYearFilter,
        NumericFilter,
        RadioFilter,
        SearchFilter,
        SelectFilter,
        PeriodFilter,
        TextFilter,
    },

    data: () => {
        return {
            drawer: false,
            resource: null,
            allowed: [],
        }
    },

    methods: {
        mount({ resource, allowed }) {
            this.resource = resource
            this.allowed = allowed
        },

        visibilityHandler(show) {
            if (show === undefined) {
                this.drawer = !this.drawer
                return
            }

            this.drawer = show
        },

        reset() {
            this.$store.commit('filters/reset', this.resource)
        },
    },
    mounted() {
        this.$bus.$on('filters', this.mount)
        this.$bus.$on('filterDrawer', this.visibilityHandler)
    },
    beforeDestroy() {
        this.$bus.$off('filters', this.mount)
        this.$bus.$off('filterDrawer', this.visibilityHandler)
    },
}
</script>

<style></style>
